import { createContext } from 'react';
import { defaultBreakpoints } from '../../theme/screen-sizes';
/**
 * Context for current breakpoints.
 */

export var BreakpointsContext = /*#__PURE__*/createContext(defaultBreakpoints);